import Entradas from "../images/Entradas.webp";
import Sopa from "../images/Wontons.webp";
import Especial from "../images/PlatoEspecial.webp";
import ChowFan from "../images/Chow-Fan.webp";
import SalsaAgridulce from "../images/salsaagriculce.webp";
import SalsaCurry from "../images/salsadecurry.webp";
import SalsaOstras from "../images/salsadeostras.webp";
import ChopSuey from "../images/chopsuey.webp";
import Vegetariano from "../images/TofuA.webp";
import Vegano from "../images/Vegano.webp";
import Mariscos from "../images/mariscos.webp";
import PlatoCombinado from "../images/ChowFan.webp";
import ToFu from "../images/ToFu.webp";
import Carnes from "../images/milanesa.webp";
import Bebidas from "../images/sodasandia.webp";
import Postres from "../images/6.webp";
import Infa from "../images/menuInfantil.webp";
import mien from "../images/lomien.webp";
import cremas from "../images/crema.webp";
import CervezaImage from "../img/cerveza.webp";
import CocteleriaImage from "../img/margarita.webp";
import GaseosasImage from "../img/gaseosa.webp";
import HatsuImage from "../img/7707362390079-30.webp";
import JugosImage from "../img/mandarina.webp";
import LicoresImage from "../img/whiskyoldparr.webp";
import SangriasImage from "../img/images.svg";
import SodasImage from "../img/lychee.webp";
import VinosImage from "../img/120.webp";
import PlatoTriple from "../img/china.webp";


export const MenuList = [
  {
    "name": "Entradas",
    "description": "Costilla asada, lumpias y wantons fritos.",
    "image": Entradas,
    "gelemento": "Ver Entradas",
    "link": "/Entradas",
  },
  {
    "name": "Sopas",
    "description": "El menú de sopas de Asia.",
    "image": Sopa,
    "gelemento": "Ver Sopas",
    "link": "/Sopas",
  },
    {
    "name": "Cremas",
    "description": "El menú de cremas de Asia.",
    "image": cremas,
    "gelemento": "Ver cremas",
    "link": "/Cremas",
  },
  {
    "name": "Platos de Especialidad",
    "description": "Opciones para diversos gustos.",
    "image": Especial,
    "gelemento": "Ver Especial",
    "link": "/PlatosEspeciales",
  },
  {
    "name": "Arroz Chino",
    "description": "Arroz frito originario de China.",
    "image": ChowFan,
    "gelemento": "Ver Arroces",
    "link": "/ArrozChino",
  },
  {
    "name": "Salsa Agridulce",
    "description": "Son especialidades chinas.",
    "image": SalsaAgridulce,
    "gelemento": "Ver Agridulces",
    "link": "/SalsaAgridulce",
  },
  {
    "name": "Salsa Curry",
    "description": "Mezcla de especias y hierbas.",
    "image": SalsaCurry,
    "gelemento": "Ver Currys",
    "link": "/SalsaCurry",
  },
  {
    "name": "Salsa Ostras",
    "description": "Salsa oscura hecha a base de ostras.",
    "image": SalsaOstras,
    "gelemento": "Ver Ostras",
    "link": "/SalsaOstras",
  },
  {
    "name": "Chop Suey",
    "description": "Plato de vegetales y carne.",
    "image": ChopSuey,
    "gelemento": "Ver Chop Sueys",
    "link": "/ChopSuey",
  },
  {
    "name": "Vegetariano",
    "description": "Rica comida china sin carne.",
    "image": Vegetariano,
    "gelemento": "Ver Vegetarianos",
    "link": "/Vegetariano",
  },
  {
    "name": "Vegano",
    "description": "Rica comida china sin carne.",
    "image": Vegano,
    "gelemento": "Ver Veganos",
    "link": "/Vegano",
  },
  {
    "name": "Platos de Mariscos",
    "description": "Camarones, langostinos, pescado y más.",
    "image": Mariscos,
    "gelemento": "Ver Mariscos",
    "link": "/Mariscos#mariscos",
  },
  {
    "name": "Platos Combinados",
    "description": "Los platos combinados de Asia.",
    "image": PlatoCombinado,
    "gelemento": "Ver Combinados",
    "link": "/PlatoCombinado",
  },
    {
    "name": "Platos Combinado Triple",
    "description": "Plato combinado Triple.",
    "image": PlatoTriple,
    "gelemento": "Ver Triples",
    "link": "/PlatoTriple",
  },
  {
    "name": "Lo mien",
    "description": "Pasta China .",
    "image": mien,
    "gelemento": "Ver Lomien",
    "link": "/Lomien",
  }, 
  {
    "name": "Tofu",
    "description": "Hecho a partir de la leche de soja.",
    "image": ToFu,
    "gelemento": "Ver Tofus",
    "link": "/Tofu",
  },
  {
    "name": "Infantil",
    "description": "Comida china para niños",
    "image": Infa,
    "gelemento": "Ver Infantil",
    "link": "/Menuinfantil",
  },
  {
    "name": "Carnes",
    "description": "Carne asada, filete mignon y cerdo milanesa.",
    "image": Carnes,
    "gelemento": "Ver Carnes",
    "link": "/Carnes",
  },
  {
    "name": "Bebidas",
    "description": "Gaseosas, té HATSU y sodas.",
    "image": Bebidas,
    "gelemento": "Ver Bebidas",
    "link": "/Bebidas",
  },
  {
    "name": "Postres",
    "description": "Tapioca, flan caramelo, cheesecake.",
    "image": Postres,
    "gelemento": "Ver Postres",
    "link": "/Postres",
  },
];


export const BebiList = [
  {
    "name": "Cerveza",
    "description": "Cerveza para acompañar tus platillos.",
    "image": CervezaImage,
    "gelemento": "Ver Cervezas",
    "link": "/Cerveza",
  },
  {
    "name": "Cocteleria",
    "description": "Variedad de cócteles para disfrutar.",
    "image": CocteleriaImage,
    "gelemento": "Ver Cocteles",
    "link": "/Cocteleria",
  },
  {
    "name": "Gaseosas",
    "description": "Refrescantes bebidas gaseosas.",
    "image": GaseosasImage,
    "gelemento": "Ver Gaseosas",
    "link": "/Gaseosas",
  },
  // Agrega las otras bebidas aquí siguiendo el mismo patrón
  {
    "name": "Hatsu",
    "description": "Descripción de Hatsu.",
    "image": HatsuImage,
    "gelemento": "Ver Hatsu",
    "link": "/Hatsu",
  },
  {
    "name": "Jugos",
    "description": "Descripción de Jugos.",
    "image": JugosImage,
    "gelemento": "Ver Jugos",
    "link": "/Jugos",
  },
  {
    "name": "Licores",
    "description": "Descripción de Licores.",
    "image": LicoresImage,
    "gelemento": "Ver Licores",
    "link": "/Licores",
  },
  {
    "name": "Sangrias",
    "description": "Descripción de Sangrias.",
    "image": SangriasImage,
    "gelemento": "Ver Sangrias",
    "link": "/Sangrias",
  },
  {
    "name": "Sodas",
    "description": "Descripción de Sodas.",
    "image": SodasImage,
    "gelemento": "Ver Sodas",
    "link": "/Sodas",
  },
  {
    "name": "Vinos",
    "description": "Descripción de Vinos.",
    "image": VinosImage,
    "gelemento": "Ver Vinos",
    "link": "/Vinos",
  },
];



export const Cartaespañol = {
  "categorias": [
    {
      "nombre": "Bebidas Refrescantes",
      "items": [
        {
          "nombre_plato": "Té Hatsu",
          "descripcion_plato": "Verde, Rosado, Negro, Amarillo, Blanco, Lila.",
          "precio_plato": "$"
        },
        {
          "nombre_plato": "Cocacola",
          "descripcion_plato": "Zero, Cuatro, Cocacola, Sprite.",
          "precio_plato": "$10.800"
        },
        {
          "nombre_plato": "Postobón",
          "descripcion_plato": "Manzana, 7up, Colombiana.",
          "precio_plato": "$10.800"
        },
        {
          "nombre_plato": "Sodas Saborizadas",
          "descripcion_plato": "Sandia, Maracuyá, Lichys.",
          "precio_plato": "$17.900"
        }
      ]
    },
    {
      "nombre": "Entradas",
      "items": [
        {
          "nombre_plato": "Wan Tun Fritos",
          "descripcion_plato": "Rellenos de camarones y carne molida, fritos.",
          "precio_plato": "$27.500"
        },
        {
          "nombre_plato": "Copa de Camarones",
          "descripcion_plato": "Camarones en copa.",
          "precio_plato": "$60.000"
        },
        {
          "nombre_plato": "Copa de Langostino",
          "descripcion_plato": "Langostino en copa.",
          "precio_plato": "$69.000"
        },
        {
          "nombre_plato": "Combinación de la Casa",
          "descripcion_plato": "Variedad de entradas clásicas.",
          "precio_plato": "$69.000"
        },
        {
          "nombre_plato": "Lumpia (Egg Roll)",
          "descripcion_plato": "Rollito frito de carne y vegetales.",
          "precio_plato": "$9.800"
        },
        {
          "nombre_plato": "Copa Huevos de Codorniz",
          "descripcion_plato": "Huevos de codorniz en copa.",
          "precio_plato": "$25.000"
        },
        {
          "nombre_plato": "Costilla Asada",
          "descripcion_plato": "Costilla asada con salsa.",
          "precio_plato": "$54.000"
        }
      ]
    },
    {
      "nombre": "Sopas",
      "items": [
        {
          "nombre_plato": "Hot and Sour",
          "descripcion_plato": "Sopa picante con pollo y cerdo.",
          "precio_plato": "$23.500"
        },
        {
          "nombre_plato": "Wan Tun (Wan Tun Mien)",
          "descripcion_plato": "Sopa de dumplings y pasta.",
          "precio_plato": "$23.500"
        },
        {
          "nombre_plato": "Sopa de Mariscos",
          "descripcion_plato": "Sopa de mariscos.",
          "precio_plato": "$26.500"
        },
        {
          "nombre_plato": "Yat Ko Mien",
          "descripcion_plato": "Sopa de pollo, jamón y cerdo con pasta.",
          "precio_plato": "$23.500"
        }
      ]
    },
    {
      "nombre": "Cremas",
      "items": [
        {
          "nombre_plato": "Crema de Langostinos",
          "descripcion_plato": "Crema de langostinos.",
          "precio_plato": "$27.500"
        },
        {
          "nombre_plato": "Crema de Camarones",
          "descripcion_plato": "Crema de camarones.",
          "precio_plato": "$25.000"
        },
        {
          "nombre_plato": "Crema de Pollo/Pescado",
          "descripcion_plato": "Crema de pollo o pescado.",
          "precio_plato": "$23.500"
        },
        {
          "nombre_plato": "Crema de Vegetales",
          "descripcion_plato": "Crema de champiñones, tomate, cebolla y brócoli.",
          "precio_plato": "$21.500"
        }
      ]
    },
    {
      "nombre": "Arroz Frito",
      "items": [
        {
          "nombre_plato": "Arroz Especial",
          "descripcion_plato": "Arroz frito especial.",
          "precio_plato": "$55.000"
        },
        {
          "nombre_plato": "Arroz Especial + Camarón",
          "descripcion_plato": "Arroz especial con camarón.",
          "precio_plato": "$64.000"
        },
        {
          "nombre_plato": "Arroz Frito de Pollo",
          "descripcion_plato": "Arroz frito con pollo.",
          "precio_plato": "$57.000"
        },
        {
          "nombre_plato": "Arroz Frito con Solomito",
          "descripcion_plato": "Arroz frito con solomito.",
          "precio_plato": "$60.000"
        },
        {
          "nombre_plato": "Arroz Frito con Langostinos",
          "descripcion_plato": "Arroz frito con langostinos.",
          "precio_plato": "$74.000"
        },
        {
          "nombre_plato": "Arroz Frito con Mariscos",
          "descripcion_plato": "Arroz frito con mariscos.",
          "precio_plato": "$67.000"
        },
        {
          "nombre_plato": "Arroz Frito con Camarones",
          "descripcion_plato": "Arroz frito con camarones.",
          "precio_plato": "$64.000"
        },
        {
          "nombre_plato": "Arroz Frito 8 Sabores",
          "descripcion_plato": "Arroz con langostino, pollo, solomito, cerdo, camarón, huevo de codorniz y jamón.",
          "precio_plato": "$64.000"
        }
      ]
    },
    {
      "nombre": "Chop Suey",
      "items": [
        {
          "nombre_plato": "Chop Suey Especial",
          "descripcion_plato": "Chop suey especial.",
          "precio_plato": "$55.000"
        },
        {
          "nombre_plato": "Chop Suey Especial + Camarón",
          "descripcion_plato": "Chop suey especial con camarón.",
          "precio_plato": "$64.000"
        },
        {
          "nombre_plato": "Chop Suey de Pollo",
          "descripcion_plato": "Chop suey de pollo.",
          "precio_plato": "$57.000"
        },
        {
          "nombre_plato": "Chop Suey con Camarones",
          "descripcion_plato": "Chop suey con camarones.",
          "precio_plato": "$64.000"
        },
        {
          "nombre_plato": "Chop Suey con Mariscos",
          "descripcion_plato": "Chop suey con mariscos.",
          "precio_plato": "$67.000"
        },
        {
          "nombre_plato": "Chop Suey con Solomito",
          "descripcion_plato": "Chop suey con solomito.",
          "precio_plato": "$60.000"
        },
        {
          "nombre_plato": "Chop Suey con Langostinos",
          "descripcion_plato": "Chop suey con langostinos.",
          "precio_plato": "$74.000"
        }
      ]
    },
    {
      "nombre": "Salsa Agridulce",
      "items": [
        {
          "nombre_plato": "Pollo en Salsa Agridulce",
          "descripcion_plato": "Pollo en salsa agridulce.",
          "precio_plato": "$57.000"
        },
        {
          "nombre_plato": "Solomito en Salsa Agridulce",
          "descripcion_plato": "Solomito en salsa agridulce.",
          "precio_plato": "$60.000"
        },
        {
          "nombre_plato": "Costilla en Salsa Agridulce",
          "descripcion_plato": "Costilla en salsa agridulce.",
          "precio_plato": "$56.000"
        },
        {
          "nombre_plato": "Langostinos en Salsa Agridulce",
          "descripcion_plato": "Langostinos en salsa agridulce.",
          "precio_plato": "$74.000"
        },
        {
          "nombre_plato": "Pescado en Salsa Agridulce",
          "descripcion_plato": "Pescado en salsa agridulce.",
          "precio_plato": "$57.000"
        },
        {
          "nombre_plato": "Cerdo en Salsa Agridulce",
          "descripcion_plato": "Cerdo en salsa agridulce.",
          "precio_plato": "$57.000"
        }
      ]
    },
    {
      "nombre": "Lo Mien (Pasta China)",
      "items": [
        {
          "nombre_plato": "Lomien con Solomito",
          "descripcion_plato": "Pasta con solomito.",
          "precio_plato": "$60.000"
        },
        {
          "nombre_plato": "Lomien con Pollo",
          "descripcion_plato": "Pasta con pollo.",
          "precio_plato": "$58.000"
        },
        {
          "nombre_plato": "Lomien con Langostinos",
          "descripcion_plato": "Pasta con langostinos.",
          "precio_plato": "$74.000"
        }
      ]
    },
    {
      "nombre": "Plato Especial",
      "items": [
        {
          "nombre_plato": "Chaw Pat Chin",
          "descripcion_plato": "Langostino, pollo, cerdo, tao fu, jamón y vegetales en soya.",
          "precio_plato": "$62.000"
        },
        {
          "nombre_plato": "Solomito con Jengibre",
          "descripcion_plato": "Solomito al jengibre.",
          "precio_plato": "$62.000"
        },
        {
          "nombre_plato": "Tocino con Jalapeño",
          "descripcion_plato": "Tocino con jalapeño.",
          "precio_plato": "$63.000"
        },
        {
          "nombre_plato": "Pollo en Salsa Naranja",
          "descripcion_plato": "Pollo en salsa naranja.",
          "precio_plato": "$61.000"
        },
        {
          "nombre_plato": "Pollo con Ajonjolí en Salsa de Mariscos",
          "descripcion_plato": "Pollo con ajonjolí y salsa de mariscos.",
          "precio_plato": "$61.000"
        },
        {
          "nombre_plato": "Pescado al Vapor con Jengibre y Cebolla",
          "descripcion_plato": "Pescado al vapor con jengibre y cebolla.",
          "precio_plato": "$70.000"
        },
        {
          "nombre_plato": "Brócoli con Pollo",
          "descripcion_plato": "Pollo con brócoli.",
          "precio_plato": "$61.000"
        },
        {
          "nombre_plato": "Brócoli con Solomito",
          "descripcion_plato": "Solomito con brócoli.",
          "precio_plato": "$63.000"
        },
        {
          "nombre_plato": "Langostinos Salteados",
          "descripcion_plato": "Langostinos salteados.",
          "precio_plato": "$76.000"
        },
        {
          "nombre_plato": "Camarones con Papa al Ajillo",
          "descripcion_plato": "Camarones con papa al ajillo.",
          "precio_plato": "$64.000"
        },
        {
          "nombre_plato": "Pollo Salteado con Verduras",
          "descripcion_plato": "Pollo salteado con verduras.",
          "precio_plato": "$61.000"
        },
        {
          "nombre_plato": "Cazuela de Solomito",
          "descripcion_plato": "Cazuela picante de solomito con col china. (Boca en llamas y orgullo herido)",
          "precio_plato": "$101.800"
        }
      ]
    },
    {
      "nombre": "Plato Combinado",
      "items": [
        {
          "nombre_plato": "Chop Suey y Arroz Especial",
          "descripcion_plato": "Chop suey y arroz especial.",
          "precio_plato": "$55.000"
        },
        {
          "nombre_plato": "Chop Suey y Cerdo en Salsa Agridulce",
          "descripcion_plato": "Chop suey y cerdo agridulce.",
          "precio_plato": "$55.000"
        },
        {
          "nombre_plato": "Arroz Especial y Cerdo en Salsa Agridulce",
          "descripcion_plato": "Arroz especial y cerdo agridulce.",
          "precio_plato": "$56.000"
        },
        {
          "nombre_plato": "Arroz Especial y Pollo en Salsa Agridulce",
          "descripcion_plato": "Arroz especial y pollo agridulce.",
          "precio_plato": "$56.000"
        }
      ]
    },
    {
      "nombre": "Plato Combinado Triple",
      "items": [
        {
          "nombre_plato": "Arroz, Chop Suey y Cerdo en Salsa Agridulce",
          "descripcion_plato": "Arroz, chop suey y cerdo agridulce.",
          "precio_plato": "$55.000"
        },
        {
          "nombre_plato": "Arroz, Chop Suey y Pollo en Salsa Agridulce",
          "descripcion_plato": "Arroz, chop suey y pollo agridulce.",
          "precio_plato": "$56.000"
        }
      ]
    },
    {
      "nombre": "Plato Combinado Pequeño",
      "items": [
        {
          "nombre_plato": "Chop Suey y Arroz Especial (Pequeño)",
          "descripcion_plato": "Chop suey y arroz especial (pequeño).",
          "precio_plato": "$37.500"
        },
        {
          "nombre_plato": "Chop Suey y Cerdo en Salsa Agridulce (Pequeño)",
          "descripcion_plato": "Chop suey y cerdo agridulce (pequeño).",
          "precio_plato": "$37.500"
        },
        {
          "nombre_plato": "Arroz Especial y Cerdo en Salsa Agridulce (Pequeño)",
          "descripcion_plato": "Arroz especial y cerdo agridulce (pequeño).",
          "precio_plato": "$37.500"
        },
        {
          "nombre_plato": "Arroz Especial y Pollo en Salsa Agridulce (Pequeño)",
          "descripcion_plato": "Arroz especial y pollo agridulce (pequeño).",
          "precio_plato": "$38.500"
        }
      ]
    },
    {
      "nombre": "Tao Fu / Frijol de Soya",
      "items": [
        {
          "nombre_plato": "Tao Fu con Pollo",
          "descripcion_plato": "Tao fu con pollo.",
          "precio_plato": "$60.000"
        },
        {
          "nombre_plato": "Tao Fu con Solomito",
          "descripcion_plato": "Tao fu con solomito.",
          "precio_plato": "$62.000"
        },
        {
          "nombre_plato": "Tao Fu con Langostinos",
          "descripcion_plato": "Tao fu con langostinos.",
          "precio_plato": "$76.000"
        },
        {
          "nombre_plato": "Mapo Tao Fu",
          "descripcion_plato": "Mapo tao fu.",
          "precio_plato": "$63.000"
        }
      ]
    },
    {
      "nombre": "Salsa de Curry",
      "items": [
        {
          "nombre_plato": "Pollo en Salsa Curry",
          "descripcion_plato": "Pollo en curry.",
          "precio_plato": "$58.000"
        },
        {
          "nombre_plato": "Solomito en Salsa Curry",
          "descripcion_plato": "Solomito en curry.",
          "precio_plato": "$60.000"
        },
        {
          "nombre_plato": "Langostinos en Salsa Curry",
          "descripcion_plato": "Langostinos en curry.",
          "precio_plato": "$74.000"
        },
        {
          "nombre_plato": "Pescado en Salsa Curry",
          "descripcion_plato": "Pescado en curry.",
          "precio_plato": "$61.000"
        },
        {
          "nombre_plato": "Camarones en Salsa Curry",
          "descripcion_plato": "Camarones en curry.",
          "precio_plato": "$64.000"
        }
      ]
    },
    {
      "nombre": "Salsa de Ostras con Raíces de Mungo",
      "items": [
        {
          "nombre_plato": "Pollo en Salsa de Ostras",
          "descripcion_plato": "Pollo en salsa de ostras.",
          "precio_plato": "$59.000"
        },
        {
          "nombre_plato": "Cerdo en Salsa de Ostras",
          "descripcion_plato": "Cerdo en salsa de ostras.",
          "precio_plato": "$59.000"
        },
        {
          "nombre_plato": "Solomito en Salsa de Ostras",
          "descripcion_plato": "Solomito en salsa de ostras.",
          "precio_plato": "$61.000"
        },
        {
          "nombre_plato": "Langostino en Salsa de Ostras",
          "descripcion_plato": "Langostino en salsa de ostras.",
          "precio_plato": "$74.000"
        },
        {
          "nombre_plato": "Pescado en Salsa de Ostras",
          "descripcion_plato": "Pescado en salsa de ostras.",
          "precio_plato": "$61.000"
        },
        {
          "nombre_plato": "Camarones en Salsa de Ostras",
          "descripcion_plato": "Camarones en salsa de ostras.",
          "precio_plato": "$64.000"
        }
      ]
    },
    {
      "nombre": "Plato Vegetariano",
      "items": [
        {
          "nombre_plato": "Arroz Frito con Raíces Chinas y Huevo en Salsa de Soya",
          "descripcion_plato": "Arroz frito con raíces chinas y huevo en salsa de soya.",
          "precio_plato": "$48.000"
        },
        {
          "nombre_plato": "Vegetales en Salsa de Soya",
          "descripcion_plato": "Vegetales en salsa de soya.",
          "precio_plato": "$48.000"
        },
        {
          "nombre_plato": "Tao Fu en Salsa Agridulce",
          "descripcion_plato": "Tao fu en salsa agridulce.",
          "precio_plato": "$48.000"
        },
        {
          "nombre_plato": "Lo Mien sin Carne",
          "descripcion_plato": "Lo mien sin carne.",
          "precio_plato": "$48.000"
        }
      ]
    },
    {
      "nombre": "Mariscos",
      "items": [
        {
          "nombre_plato": "Langostinos Mariposa",
          "descripcion_plato": "Langostinos mariposa.",
          "precio_plato": "$74.000"
        },
        {
          "nombre_plato": "Langostinos a la Plancha",
          "descripcion_plato": "Langostinos a la plancha.",
          "precio_plato": "$74.000"
        },
        {
          "nombre_plato": "Langostinos al Ajillo",
          "descripcion_plato": "Langostinos al ajillo.",
          "precio_plato": "$74.000"
        },
        {
          "nombre_plato": "Langostinos Salteados con Sal y Pimienta",
          "descripcion_plato": "Langostinos salteados con sal y pimienta.",
          "precio_plato": "$76.000"
        },
        {
          "nombre_plato": "Cazuela de Mariscos",
          "descripcion_plato": "Cazuela de mariscos.",
          "precio_plato": "$72.000"
        },
        {
          "nombre_plato": "Camarones al Ajillo con Papas al Vapor",
          "descripcion_plato": "Camarones al ajillo con papas al vapor.",
          "precio_plato": "$64.000"
        },
        {
          "nombre_plato": "Pescado con Vegetales en Salsa de Soya",
          "descripcion_plato": "Pescado con vegetales en salsa de soya.",
          "precio_plato": "$61.000"
        },
        {
          "nombre_plato": "Pescado a la Plancha",
          "descripcion_plato": "Pescado a la plancha.",
          "precio_plato": "$61.000"
        },
        {
          "nombre_plato": "Pescado a la Milanesa",
          "descripcion_plato": "Pescado a la milanesa.",
          "precio_plato": "$61.000"
        }
      ]
    },
    {
      "nombre": "Carnes",
      "items": [
        {
          "nombre_plato": "Solomito con Pimentón",
          "descripcion_plato": "Solomito con pimentón.",
          "precio_plato": "$62.000"
        },
        {
          "nombre_plato": "Solomito con Vegetales en Salsa de Vino",
          "descripcion_plato": "Solomito con vegetales en salsa de vino.",
          "precio_plato": "$63.000"
        },
        {
          "nombre_plato": "Solomito Asado",
          "descripcion_plato": "Solomito asado.",
          "precio_plato": "$63.000"
        },
        {
          "nombre_plato": "Cerdo Asado o a la Milanesa",
          "descripcion_plato": "Cerdo asado o a la milanesa.",
          "precio_plato": "$62.000"
        },
        {
          "nombre_plato": "Chuleta a la Milanesa",
          "descripcion_plato": "Chuleta a la milanesa.",
          "precio_plato": "$62.000"
        },
        {
          "nombre_plato": "Filet Mignon con Champiñones",
          "descripcion_plato": "Filet mignon con champiñones.",
          "precio_plato": "$63.000"
        },
        {
          "nombre_plato": "Porción de Arroz Blanco",
          "descripcion_plato": "Porción de arroz blanco.",
          "precio_plato": "$11.800"
        }
      ]
    },
    {
      "nombre": "Menú Infantil",
      "items": [
        {
          "nombre_plato": "Papas a la francesa y croquetas de pollo con salsa agridulce",
          "descripcion_plato": "",
          "precio_plato": "$"
        }
      ]
    },
    {
      "nombre": "Cocktails",
      "items": [
        {
          "nombre_plato": "Escorpión",
          "descripcion_plato": "Ron, brandy y jugos.",
          "precio_plato": "$27.500"
        },
        {
          "nombre_plato": "Mai Tai",
          "descripcion_plato": "Ron y jugo.",
          "precio_plato": "$27.500"
        },
        {
          "nombre_plato": "Piña Colada",
          "descripcion_plato": "Piña colada.",
          "precio_plato": "$27.500"
        },
        {
          "nombre_plato": "Ruso Blanco",
          "descripcion_plato": "Crema de café y leche.",
          "precio_plato": "$27.500"
        },
        {
          "nombre_plato": "Padrino",
          "descripcion_plato": "Whisky y amaretto.",
          "precio_plato": "$27.500"
        },
        {
          "nombre_plato": "Mojito",
          "descripcion_plato": "Mojito.",
          "precio_plato": "$27.500"
        },
        {
          "nombre_plato": "Margarita",
          "descripcion_plato": "Tequila y zumo de limón.",
          "precio_plato": "$27.500"
        },
        {
          "nombre_plato": "Shirley Temple",
          "descripcion_plato": "Para niños.",
          "precio_plato": "$19.500"
        }
      ]
    },
    {
      "nombre": "Licores",
      "items": [
        {
          "nombre_plato": "Aguardiente (trago)",
          "descripcion_plato": "Aguardiente.",
          "precio_plato": "$19.500"
        },
        {
          "nombre_plato": "Ron (trago)",
          "descripcion_plato": "Ron.",
          "precio_plato": "$17.000"
        },
        {
          "nombre_plato": "Whisky (trago)",
          "descripcion_plato": "Whisky.",
          "precio_plato": "$27.000"
        },
        {
          "nombre_plato": "Brandy, Vodka, Ginebra",
          "descripcion_plato": "Brandy, Vodka y Ginebra.",
          "precio_plato": "$25.000"
        }
      ]
    },
    {
      "nombre": "Vinos",
      "items": [
        {
          "nombre_plato": "Dubonnet, Jerez",
          "descripcion_plato": "Dubonnet y Jerez.",
          "precio_plato": "$25.500"
        },
        {
          "nombre_plato": "Extranjero",
          "descripcion_plato": "Vino extranjero.",
          "precio_plato": "$25.500"
        },
        {
          "nombre_plato": "Camapari",
          "descripcion_plato": "Camapari.",
          "precio_plato": "$25.500"
        },
        {
          "nombre_plato": "Vino Caliente",
          "descripcion_plato": "Vino caliente.",
          "precio_plato": "$29.500"
        }
      ]
    },
    {
      "nombre": "Bebidas",
      "items": [
        {
          "nombre_plato": "Soda Saborizada (lychee, sandía, maracuyá)",
          "descripcion_plato": "Soda saborizada.",
          "precio_plato": "$17.900"
        },
        {
          "nombre_plato": "Gaseosa",
          "descripcion_plato": "Gaseosa.",
          "precio_plato": "$10.800"
        },
        {
          "nombre_plato": "Cerveza Nacional",
          "descripcion_plato": "Cerveza nacional.",
          "precio_plato": "$15.900"
        },
        {
          "nombre_plato": "Cerveza Heineken / Corona",
          "descripcion_plato": "Heineken o Corona.",
          "precio_plato": "$17.900"
        },
        {
          "nombre_plato": "Cerveza Coronita",
          "descripcion_plato": "Cerveza Coronita.",
          "precio_plato": "$15.900"
        },
        {
          "nombre_plato": "Jugo en Leche",
          "descripcion_plato": "Jugo en leche.",
          "precio_plato": "$14.900"
        },
        {
          "nombre_plato": "Jugo en Agua",
          "descripcion_plato": "Jugo en agua.",
          "precio_plato": "$13.800"
        },
        {
          "nombre_plato": "Limonada",
          "descripcion_plato": "Limonada.",
          "precio_plato": "$13.800"
        },
        {
          "nombre_plato": "Jugo de Naranja",
          "descripcion_plato": "Jugo de naranja.",
          "precio_plato": "$16.000"
        }
      ]
    },
    {
      "nombre": "Postres",
      "items": [
        {
          "nombre_plato": "Lichis (Pomarosa China)",
          "descripcion_plato": "Lichis (Pomarosa China).",
          "precio_plato": "$22.000"
        },
        {
          "nombre_plato": "Flan de Coco",
          "descripcion_plato": "Flan de coco.",
          "precio_plato": "$22.000"
        },
        {
          "nombre_plato": "Flan de Caramelo",
          "descripcion_plato": "Flan de caramelo.",
          "precio_plato": "$22.000"
        },
        {
          "nombre_plato": "Cheese Cake",
          "descripcion_plato": "Cheese cake.",
          "precio_plato": "$22.000"
        },
        {
          "nombre_plato": "Nata",
          "descripcion_plato": "Nata.",
          "precio_plato": "$22.000"
        },
        {
          "nombre_plato": "Té de China",
          "descripcion_plato": "Té de China.",
          "precio_plato": "$9.900"
        },
        {
          "nombre_plato": "Tapioca con Mango",
          "descripcion_plato": "Tapioca con mango.",
          "precio_plato": "$23.000"
        }
      ]
    }
  ]
};




export const Cartachino = {
  "categorias": [
    {
      "nombre": "清爽饮品",
      "items": [
        {
          "nombre_plato": "茶Hatsu",
          "descripcion_plato": "绿茶，粉红色，红茶，白茶，紫茶。",
          "precio_plato": " $"
        },
        {
          "nombre_plato": "可口可乐",
          "descripcion_plato": "零度，健怡，可口可乐，雪碧。",
          "precio_plato": " $"
        },
        {
          "nombre_plato": "波士顿",
          "descripcion_plato": "苹果，7UP，橙汁。",
          "precio_plato": " $"
        },
        {
          "nombre_plato": "果味汽水",
          "descripcion_plato": "西瓜，百香果，荔枝。",
          "precio_plato": " $"
        }
      ]
    },

    {
      "nombre": "开胃菜",
      "items": [
        {
          "nombre_plato": "春卷",
          "descripcion_plato": "炸卷，肉和蔬菜。",
         "precio_plato": ""
        },
        {
          "nombre_plato": "烤排骨",
          "descripcion_plato": "多汁的烤排骨，配烧烤酱。",
          "precio_plato": ""
        },
        {
          "nombre_plato": "炸云吞",
          "descripcion_plato": "炸云吞脆饼（不含肉或蔬菜）。",
          "precio_plato": ""
        },
        {
          "nombre_plato": "虾仁鸡尾酒",
          "descripcion_plato": "粉红酱汁中的美味虾仁，去壳，干净，新鲜。",
          "precio_plato": ""
        },
        {
          "nombre_plato": "虾仁杯",
          "descripcion_plato": "杯中的新鲜虾仁。",
       "precio_plato": ""
        },
        {
          "nombre_plato": "招牌拼盘",
          "descripcion_plato": "各种肉类，鸡肉，猪肉，虾仁，春卷，排骨和炸云吞的拼盘。",
         "precio_plato": ""
        },
        {
          "nombre_plato": "鹌鹑蛋杯",
          "descripcion_plato": "杯中的鹌鹑蛋。",
           "precio_plato": ""
        }
      ]
    },

    {
      "nombre": "汤",
      "items": [
        {
          "nombre_plato": "酸辣汤",
          "descripcion_plato": "猪肉块，豆腐，微辣。",
          "precio_plato": ""
        },
        {
          "nombre_plato": "云吞汤",
          "descripcion_plato": "肉和蔬菜与面条和鸡蛋的汤。",
           "precio_plato": ""
        },
        {
          "nombre_plato": "一口面",
          "descripcion_plato": "鸡肉汤，面条和蔬菜。",
         "precio_plato": ""
        },
        {
          "nombre_plato": "虾仁奶油汤",
          "descripcion_plato": "奶油汤，虾仁块。",
           "precio_plato": ""
        },
        {
          "nombre_plato": "龙虾奶油汤",
          "descripcion_plato": "奶油汤，龙虾块。",
           "precio_plato": ""
        },
        {
          "nombre_plato": "洋葱奶油汤",
          "descripcion_plato": "奶油汤，洋葱块。",
          "precio_plato": ""
        },
        {
          "nombre_plato": "西兰花奶油汤",
          "descripcion_plato": "奶油汤，西兰花块。",
         "precio_plato": ""
        },
        {
          "nombre_plato": "鸡肉奶油汤",
          "descripcion_plato": "奶油汤，鸡肉块。",
         "precio_plato": ""
        },
        {
          "nombre_plato": "鱼块奶油汤",
          "descripcion_plato": "奶油汤，鱼块。",
          "precio_plato": ""
        }
      ]
    },
    {
      "nombre": "Chinese Rice",
      "items": [
        {
          "nombre_plato": "鸡肉炒饭",
          "descripcion_plato": "鸡肉，山药，洋葱的炒饭。",
        
        },
        {
          "nombre_plato": "牛肉饭",
          "descripcion_plato": "牛肉的饭。",
          "precio_plato": ""
        },
        {
          "nombre_plato": "虾仁炒饭",
          "descripcion_plato": "只有虾仁的广东炒饭。",
           "precio_plato": ""
        },
        {
          "nombre_plato": "海鲜饭",
          "descripcion_plato": "海鲜的饭。",
          "precio_plato": ""
        },
        {
          "nombre_plato": "虾炒饭",
          "descripcion_plato": "虾的炒饭。",
          "precio_plato": ""
        },
        {
          "nombre_plato": "八味炒饭",
          "descripcion_plato": "虾，牛肉，鱿鱼，鸡肉，虾，猪肉，鱼和火腿的炒饭。",
          "precio_plato": ""
        },
        {
          "nombre_plato": "特色炒饭",
          "descripcion_plato": "特色的中式炒饭，配有鸡肉，猪肉，火腿和鸡蛋（只有特色炒饭包括黄蛋）。",
           "precio_plato": ""
        },
        {
          "nombre_plato": "半份特色炒饭",
          "descripcion_plato": "小份的特色炒饭，配有鸡肉，猪肉，火腿。",
          "precio_plato": ""
        },
        {
          "nombre_plato": "特色炒饭配虾仁",
          "descripcion_plato": "特色的中式炒饭，配有鸡肉，猪肉，火腿和虾仁。",
          "precio_plato": ""
        }
      ]
    },
    {
      "nombre": "特色菜",
      "items": [
        {
          "nombre_plato": "橙味鸡",
          "descripcion_plato": "美味的鸡胸块浸泡在橙汁中。",
     "precio_plato": ""
        },
        {
          "nombre_plato": "菠萝鸡",
          "descripcion_plato": "新鲜的菠萝块搭配精致的鸡肉。",
          "precio_plato": ""
        },
        {
          "nombre_plato": "杂碎菜",
          "descripcion_plato": "虾，牛肉，豆腐，鸡肉，虾，猪肉，鱼和各种蔬菜。",
           "precio_plato": ""
        },
        {
          "nombre_plato": "西兰花鸡",
          "descripcion_plato": "鸡肉在豉油上的西兰花床上。",
          "precio_plato": ""
        },
        {
          "nombre_plato": "西兰花牛肉",
          "descripcion_plato": "牛肉在豉油上的西兰花床上。",
          "precio_plato": ""
        },
        {
          "nombre_plato": "西兰花虾",
          "descripcion_plato": "豉油西兰花床上的炒虾。",
         "precio_plato": ""
        },
        {
          "nombre_plato": "海鲜芝士汁鸡",
          "descripcion_plato": "鸡肉浸泡在海鲜和芝士酱中。",
           "precio_plato": ""
        },
        {
          "nombre_plato": "珍珠鸡",
          "descripcion_plato": "珍珠鸡在玉米粒床上。",
          "precio_plato": ""
        },
        {
          "nombre_plato": "珍珠鸡牛肉",
          "descripcion_plato": "牛肉在玉米粒床上。",
          "precio_plato": ""
        },
        {
          "nombre_plato": "虾仁炒菜",
          "descripcion_plato": "香料炒虾。",
         "precio_plato": ""
        },
        {
          "nombre_plato": "牛肉姜汁蚝油酱",
          "descripcion_plato": "美味的牛肉块浸泡在酱汁中。",
           "precio_plato": ""
        },
        {
          "nombre_plato": "蒜蓉土豆炒虾",
          "descripcion_plato": "大蒜与蒸土豆和虾。",
          "precio_plato": ""
        },
        {
          "nombre_plato": "培根辣椒",
          "descripcion_plato": "细碎的培根搭配超辣的辣椒。",
           "precio_plato": ""
        }
      ]
    },
    {
      "nombre": "甜酸酱",
      "items": [
        {
          "nombre_plato": "甜酸鸡",
          "descripcion_plato": "甜酸鸡酱与鸡肉。",
          "precio_plato": ""
        },
        {
          "nombre_plato": "甜酸猪肉",
          "descripcion_plato": "甜酸猪肉酱与猪肉。",
          "precio_plato": ""
        },
        {
          "nombre_plato": "甜酸虾",
          "descripcion_plato": "甜酸虾酱与虾。",
         "precio_plato": ""
        },
        {
          "nombre_plato": "甜酸鱼",
          "descripcion_plato": "甜酸鱼酱与鱼。",
          "precio_plato": ""
        },
        {
          "nombre_plato": "甜酸排骨",
          "descripcion_plato": "甜酸排骨酱与排骨。",
           "precio_plato": ""
        },
        {
          "nombre_plato": "小份甜酸鸡",
          "descripcion_plato": "小份甜酸鸡酱与鸡肉。",
           "precio_plato": ""
        }
      ]
    },
    {
      "nombre": "咖喱酱",
      "items": [
        {
          "nombre_plato": "咖喱鸡",
          "descripcion_plato": "咖喱鸡。",
         "precio_plato": ""
        },
        {
          "nombre_plato": "咖喱虾",
          "descripcion_plato": "咖喱虾。",
         "precio_plato": ""
        },
        {
          "nombre_plato": "咖喱鱼",
          "descripcion_plato": "咖喱鱼。",
           "precio_plato": ""
        },
        {
          "nombre_plato": "咖喱虾",
          "descripcion_plato": "咖喱虾。",
           "precio_plato": ""
        }
      ]
    },
    {
      "nombre": "蚝油酱",
      "items": [
        {
          "nombre_plato": "蚝油鸡",
          "descripcion_plato": "蚝油鸡。",
          "precio_plato": ""
        },
        {
          "nombre_plato": "蚝油牛肉",
          "descripcion_plato": "蚝油牛肉。",
           "precio_plato": ""
        },
        {
          "nombre_plato": "蚝油虾",
          "descripcion_plato": "蚝油虾。",
         "precio_plato": ""
        },
        {
          "nombre_plato": "蚝油鱼",
          "descripcion_plato": "蚝油鱼。",
          "precio_plato": ""
        }
      ]
    },
    {
      "nombre": "黑椒酱",
      "items": [
        {
          "nombre_plato": "黑椒牛肉",
          "descripcion_plato": "黑椒牛肉。",
         "precio_plato": ""
        },
        {
          "nombre_plato": "黑椒虾",
          "descripcion_plato": "黑椒虾。",
          "precio_plato": ""
        },
        {
          "nombre_plato": "黑椒鱼",
          "descripcion_plato": "黑椒鱼。",
           "precio_plato": ""
        }
      ]
    },
    {
      "nombre": "素食",
      "items": [
        {
          "nombre_plato": "蔬菜炒面",
          "descripcion_plato": "蔬菜炒面。",
          "precio_plato": ""
        },
        {
          "nombre_plato": "蔬菜炒饭",
          "descripcion_plato": "蔬菜炒饭。",
           "precio_plato": ""
        },
        {
          "nombre_plato": "三宝炒饭",
          "descripcion_plato": "蔬菜炒饭，配有三种蔬菜。",
         "precio_plato": ""
        },
        {
          "nombre_plato": "西兰花炒蘑菇",
          "descripcion_plato": "西兰花炒蘑菇。",
          "precio_plato": ""
        },
        {
          "nombre_plato": "芦笋炒蘑菇",
          "descripcion_plato": "芦笋炒蘑菇。",
           "precio_plato": ""
        },
        {
          "nombre_plato": "白菜炒蘑菇",
          "descripcion_plato": "白菜炒蘑菇。",
          "precio_plato": ""
        },
        {
          "nombre_plato": "辣椒豆腐",
          "descripcion_plato": "辣椒豆腐。",
           "precio_plato": ""
        },
        {
          "nombre_plato": "红豆沙",
          "descripcion_plato": "红豆沙甜汤。",
           "precio_plato": ""
        }
      ]
    },
    {
      "nombre": "面食",
      "items": [
        {
          "nombre_plato": "云吞面",
          "descripcion_plato": "肉和蔬菜与面条和鸡蛋的汤。",
         "precio_plato": ""
        },
        {
          "nombre_plato": "鸡肉云吞面",
          "descripcion_plato": "鸡肉和蔬菜与面条和鸡蛋的汤。",
          "precio_plato": ""
        },
        {
          "nombre_plato": "虾仁云吞面",
          "descripcion_plato": "虾仁和蔬菜与面条和鸡蛋的汤。",
          "precio_plato": ""
        },
        {
          "nombre_plato": "虾仁面",
          "descripcion_plato": "虾仁和蔬菜与面条和鸡蛋的汤。",
         "precio_plato": ""
        }
      ]
    },
    {
      "nombre": "炸鸡",
      "items": [
        {
          "nombre_plato": "香辣鸡",
          "descripcion_plato": "香辣炸鸡。",
         "precio_plato": ""
        },
        {
          "nombre_plato": "原味鸡",
          "descripcion_plato": "原味炸鸡。",
          "precio_plato": ""
        },
        {
          "nombre_plato": "鸡翅膀",
          "descripcion_plato": "炸鸡翅膀。",
          "precio_plato": ""
        },
        {
          "nombre_plato": "鸡腿",
          "descripcion_plato": "炸鸡腿。",
          "precio_plato": ""
        }
      ]
    },
    {
      "nombre": "配菜",
      "items": [
        {
          "nombre_plato": "白饭",
          "descripcion_plato": "白饭。",
          "precio_plato": ""
        },
        {
          "nombre_plato": "炒面",
          "descripcion_plato": "炒面。",
           "precio_plato": ""
        },
        {
          "nombre_plato": "炒饭",
          "descripcion_plato": "炒饭。",
          "precio_plato": ""
        },
        {
          "nombre_plato": "薯条",
          "descripcion_plato": "薯条。",
        "precio_plato": ""
        },
        {
          "nombre_plato": "炸云吞",
          "descripcion_plato": "炸云吞。",
          "precio_plato": ""
        },
        {
          "nombre_plato": "白米饭",
          "descripcion_plato": "白米饭。",
        "precio_plato": ""
        },
        {
          "nombre_plato": "鸡蛋面",
          "descripcion_plato": "鸡蛋面。",
          "precio_plato": ""
        },
        {
          "nombre_plato": "鸡蛋炒饭",
          "descripcion_plato": "鸡蛋炒饭。",
          "precio_plato": ""
        }
      ]
    },
    {
      "nombre": "汤面",
      "items": [
        {
          "nombre_plato": "鸡蛋汤面",
          "descripcion_plato": "鸡蛋和面条的汤。",
        "precio_plato": ""
        },
        {
          "nombre_plato": "鸡蛋炒汤面",
          "descripcion_plato": "鸡蛋和面条的炒汤。",
           "precio_plato": ""
        },
        {
          "nombre_plato": "虾仁汤面",
          "descripcion_plato": "虾仁和面条的汤。",
          "precio_plato": ""
        },
        {
          "nombre_plato": "虾仁炒汤面",
          "descripcion_plato": "虾仁和面条的炒汤。",
          "precio_plato": " "
        }
      ]
    }
  ]
};





export const Cartausa = {
  "categories": [
    {
      "name": "Refreshing Drinks",
      "items": [
        {
          "dish_name": "Te Hatsu",
          "dish_description": "Green, Pink, Black, Yellow, White, Lilac.",
          "dish_price": "$"
        },
        {
          "dish_name": "Coca‑Cola",
          "dish_description": "Zero, Diet, Coca‑Cola, Sprite.",
          "dish_price": "$10,800"
        },
        {
          "dish_name": "Postobón",
          "dish_description": "Apple, 7UP, Colombiana.",
          "dish_price": "$10,800"
        },
        {
          "dish_name": "Flavored Sodas",
          "dish_description": "Watermelon, Passion Fruit, Lychee.",
          "dish_price": "$17,900"
        }
      ]
    },
    {
      "name": "Appetizers",
      "items": [
        {
          "dish_name": "Lumpia",
          "dish_description": "Pork and vegetable fried roll with sweet and sour sauce.",
          "dish_price": "$9,800"
        },
        {
          "dish_name": "Grilled Ribs",
          "dish_description": "Juicy barbecued ribs with barbecue sauce.",
          "dish_price": "$54,000"
        },
        {
          "dish_name": "Wan Tun Fritos",
          "dish_description": "Fried dumplings filled with shrimp and minced meat.",
          "dish_price": "$27,500"
        },
        {
          "dish_name": "Prawn Cup",
          "dish_description": "Cup with prawn (langostino) in pink sauce.",
          "dish_price": "$69,000"
        },
        {
          "dish_name": "Shrimp Cup",
          "dish_description": "Cup with fresh shrimp.",
          "dish_price": "$60,000"
        },
        {
          "dish_name": "House Combination",
          "dish_description": "Assorted plate of classic appetizers.",
          "dish_price": "$69,000"
        },
        {
          "dish_name": "Quail Egg Cup",
          "dish_description": "Quail eggs in pink sauce.",
          "dish_price": "$25,000"
        }
      ]
    },
    {
      "name": "Soups",
      "items": [
        {
          "dish_name": "Hot and Sour",
          "dish_description": "Spicy soup with pork and tofu.",
          "dish_price": "$23,500"
        },
        {
          "dish_name": "Wan Tun Soup",
          "dish_description": "Soup with dumplings and noodles.",
          "dish_price": "$23,500"
        },
        {
          "dish_name": "Yat Ko Mien",
          "dish_description": "Soup with chicken, ham, and pork with noodles.",
          "dish_price": "$23,500"
        },
        {
          "dish_name": "Seafood Soup",
          "dish_description": "Chinese‑style seafood soup.",
          "dish_price": "$26,500"
        }
      ]
    },
    {
      "name": "Cream Soup",
      "items": [
        {
          "dish_name": "Shrimp Cream Soup",
          "dish_description": "Cream soup with shrimp pieces.",
          "dish_price": "$25,000"
        },
        {
          "dish_name": "Prawn Cream Soup",
          "dish_description": "Cream soup with prawn pieces.",
          "dish_price": "$27,500"
        },
        {
          "dish_name": "Onion Cream Soup",
          "dish_description": "Cream soup with onion bits.",
          "dish_price": "$20,500"
        },
        {
          "dish_name": "Broccoli Cream Soup",
          "dish_description": "Cream soup with broccoli pieces.",
          "dish_price": "$20,500"
        },
        {
          "dish_name": "Chicken Cream Soup",
          "dish_description": "Cream soup with chicken chunks.",
          "dish_price": "$22,500"
        },
        {
          "dish_name": "Fish Cream Soup",
          "dish_description": "Cream soup with fish bits.",
          "dish_price": "$22,500"
        }
      ]
    },
    {
      "name": "Special Dishes",
      "items": [
        {
          "dish_name": "Orange Chicken",
          "dish_description": "Chicken in orange sauce.",
          "dish_price": "$61,000"
        },
        {
          "dish_name": "Chaw Pat Chin",
          "dish_description": "Shrimp, tofu, chicken, pork, ham, and vegetables in soy sauce.",
          "dish_price": "$62,000"
        },
        {
          "dish_name": "Broccoli Chicken",
          "dish_description": "Chicken in seafood sauce on a bed of broccoli.",
          "dish_price": "$61,000"
        },
        {
          "dish_name": "Broccoli Beef",
          "dish_description": "Beef in seafood sauce on a bed of broccoli.",
          "dish_price": "$63,000"
        },
        {
          "dish_name": "Sesame Chicken in Seafood Sauce",
          "dish_description": "Chicken with sesame in seafood sauce.",
          "dish_price": "$61,000"
        },
        {
          "dish_name": "Sautéed Langostinos",
          "dish_description": "Stir‑fried langostinos with spices and salt.",
          "dish_price": "$76,000"
        },
        {
          "dish_name": "Beef with Ginger in Oyster Sauce",
          "dish_description": "Beef in oyster sauce with ginger.",
          "dish_price": "$60,000"
        },
        {
          "dish_name": "Garlic Steamed Shrimp with Potatoes",
          "dish_description": "Steamed shrimp with garlic and potatoes.",
          "dish_price": "$64,000"
        },
        {
          "dish_name": "Bacon with Jalapeños",
          "dish_description": "Bacon with chopped jalapeños.",
          "dish_price": "$63,000"
        },
        {
          "dish_name": "Spicy Beef Stew",
          "dish_description": "Spicy chopped beef stew with Chinese cabbage. (Warning: Mouth on fire and wounded pride)",
          "dish_price": "$101,800"
        }
      ]
    },
    {
      "name": "Chinese Fried Rice",
      "items": [
        {
          "dish_name": "Chinese Chicken Fried Rice",
          "dish_description": "Fried rice with chicken, roots, and onion.",
          "dish_price": "$55,000"
        },
        {
          "dish_name": "Beef Fried Rice",
          "dish_description": "Fried rice with beef.",
          "dish_price": "$58,000"
        },
        {
          "dish_name": "Prawn Rice",
          "dish_description": "Fried rice with prawns.",
          "dish_price": "$72,000"
        },
        {
          "dish_name": "Shrimp Fried Rice",
          "dish_description": "Fried rice with shrimp.",
          "dish_price": "$62,000"
        },
        {
          "dish_name": "8‑Flavor Rice",
          "dish_description": "Stir‑fried rice with shrimp, beef, chicken, pork, and ham.",
          "dish_price": "$62,000"
        },
        {
          "dish_name": "Special Rice",
          "dish_description": "Special Chinese rice with chicken, pork, ham, and egg.",
          "dish_price": "$53,000"
        },
        {
          "dish_name": "Half Special Rice with Shrimp",
          "dish_description": "Half portion of special rice with shrimp.",
          "dish_price": "$44,000"
        }
      ]
    },
    {
      "name": "Sweet and Sour Sauce",
      "items": [
        {
          "dish_name": "Sweet & Sour Chicken",
          "dish_description": "Chicken in sweet and sour sauce.",
          "dish_price": "$57,000"
        },
        {
          "dish_name": "Sweet & Sour Pork",
          "dish_description": "Pork in sweet and sour sauce.",
          "dish_price": "$57,000"
        },
        {
          "dish_name": "Sweet & Sour Prawns",
          "dish_description": "Prawns in sweet and sour sauce.",
          "dish_price": "$74,000"
        },
        {
          "dish_name": "Sweet & Sour Fish",
          "dish_description": "Fish in sweet and sour sauce.",
          "dish_price": "$57,000"
        },
        {
          "dish_name": "Sweet & Sour Ribs",
          "dish_description": "Ribs in sweet and sour sauce.",
          "dish_price": "$56,000"
        },
        {
          "dish_name": "Half Sweet & Sour Chicken",
          "dish_description": "Half portion of chicken in sweet and sour sauce.",
          "dish_price": "$38,500"
        }
      ]
    },
    {
      "name": "Curry Sauce",
      "items": [
        {
          "dish_name": "Chicken Curry Sauce",
          "dish_description": "Chicken with curry sauce, steamed potatoes, and onion.",
          "dish_price": "$58,000"
        },
        {
          "dish_name": "Prawn Curry Sauce",
          "dish_description": "Prawns with curry sauce, steamed potatoes, and onion.",
          "dish_price": "$74,000"
        },
        {
          "dish_name": "Fish Curry Sauce",
          "dish_description": "Fish with curry sauce, steamed potatoes, and onion.",
          "dish_price": "$61,000"
        }
      ]
    },
    {
      "name": "Oyster Sauce",
      "items": [
        {
          "dish_name": "Chicken with Oyster Sauce",
          "dish_description": "Chicken with oyster sauce, Chinese roots, and onion.",
          "dish_price": "$59,000"
        },
        {
          "dish_name": "Pork with Oyster Sauce",
          "dish_description": "Pork with oyster sauce, Chinese roots, and onion.",
          "dish_price": "$59,000"
        },
        {
          "dish_name": "Beef with Oyster Sauce",
          "dish_description": "Beef with oyster sauce, Chinese roots, and onion.",
          "dish_price": "$61,000"
        },
        {
          "dish_name": "Prawn with Oyster Sauce",
          "dish_description": "Prawns with oyster sauce, Chinese roots, and onion.",
          "dish_price": "$74,000"
        },
        {
          "dish_name": "Fish with Oyster Sauce",
          "dish_description": "Fish with oyster sauce, Chinese roots, and onion.",
          "dish_price": "$61,000"
        }
      ]
    },
    {
      "name": "Chop Suey",
      "items": [
        {
          "dish_name": "Chop Suey with Chicken",
          "dish_description": "Chicken and vegetables in soy sauce.",
          "dish_price": "$57,000"
        },
        {
          "dish_name": "Chop Suey with Beef",
          "dish_description": "Beef and vegetables in soy sauce.",
          "dish_price": "$60,000"
        },
        {
          "dish_name": "Chop Suey with Prawn",
          "dish_description": "Prawn and vegetables in soy sauce.",
          "dish_price": "$64,000"
        },
        {
          "dish_name": "Chop Suey with Seafood",
          "dish_description": "Seafood and vegetables in soy sauce.",
          "dish_price": "$67,000"
        },
        {
          "dish_name": "Chop Suey with Shrimp",
          "dish_description": "Shrimp and vegetables in soy sauce.",
          "dish_price": "$64,000"
        },
        {
          "dish_name": "Special Chop Suey with Chicken, Pork, Ham",
          "dish_description": "Special chop suey with chicken, pork, ham, and vegetables in soy sauce.",
          "dish_price": "$55,000"
        },
        {
          "dish_name": "Half Chop Suey with Chicken, Pork, Ham",
          "dish_description": "Half portion of chop suey with chicken, pork, ham, and vegetables in soy sauce.",
          "dish_price": "$37,000"
        },
        {
          "dish_name": "Half Special Chop Suey with Chicken, Pork, Ham + Shrimp",
          "dish_description": "Half portion of special chop suey with chicken, pork, ham, shrimp, and vegetables in soy sauce.",
          "dish_price": "$44,000"
        }
      ]
    },
    {
      "name": "Vegetarian Dishes",
      "items": [
        {
          "dish_name": "Meatless Lo Mein",
          "dish_description": "Lo mein without meat.",
          "dish_price": "$48,000"
        },
        {
          "dish_name": "Fried Rice with Roots and Egg",
          "dish_description": "Fried rice with Chinese roots and egg in soy sauce.",
          "dish_price": "$48,000"
        },
        {
          "dish_name": "Vegetables in Soy Sauce",
          "dish_description": "Mixed vegetables in soy sauce.",
          "dish_price": "$48,000"
        },
        {
          "dish_name": "Tofu in Sweet & Sour Sauce",
          "dish_description": "Tofu in sweet and sour sauce.",
          "dish_price": "$48,000"
        }
      ]
    },
    {
      "name": "Seafood",
      "items": [
        {
          "dish_name": "Butterfly Prawns",
          "dish_description": "Prawns prepared butterfly style with bacon and French fries.",
          "dish_price": "$74,000"
        },
        {
          "dish_name": "Grilled Prawns",
          "dish_description": "Fresh prawns grilled with an Asian touch and French fries.",
          "dish_price": "$74,000"
        },
        {
          "dish_name": "Garlic Prawn",
          "dish_description": "Prawns sautéed in garlic with steamed potatoes.",
          "dish_price": "$74,000"
        },
        {
          "dish_name": "Seafood Casserole",
          "dish_description": "Casserole with fresh seafood in house red sauce.",
          "dish_price": "$72,000"
        },
        {
          "dish_name": "Fish with Vegetables in Soy Sauce",
          "dish_description": "Fresh fish fillet with sautéed vegetables in soy sauce.",
          "dish_price": "$61,000"
        },
        {
          "dish_name": "Breaded Fish",
          "dish_description": "Breaded and fried fish served with French fries and salad.",
          "dish_price": "$61,000"
        },
        {
          "dish_name": "Grilled Fish",
          "dish_description": "Fish fillet grilled with French fries and salad.",
          "dish_price": "$61,000"
        }
      ]
    },
    {
      "name": "Combination Dishes",
      "items": [
        {
          "dish_name": "Chop Suey and Special Rice",
          "dish_description": "Fried rice with chop suey.",
          "dish_price": "$55,000"
        },
        {
          "dish_name": "Chop Suey and Sweet & Sour Pork",
          "dish_description": "Chop suey with sweet and sour pork croquettes.",
          "dish_price": "$55,000"
        },
        {
          "dish_name": "Special Rice and Sweet & Sour Pork",
          "dish_description": "Fried rice with sweet and sour pork croquettes.",
          "dish_price": "$56,000"
        },
        {
          "dish_name": "Special Rice and Sweet & Sour Chicken",
          "dish_description": "Fried rice with sweet and sour chicken croquettes.",
          "dish_price": "$56,000"
        },
        {
          "dish_name": "Triple Chicken Combination",
          "dish_description": "Rice, chop suey, and sweet & sour chicken.",
          "dish_price": "$56,000"
        },
        {
          "dish_name": "Triple Pork Combination",
          "dish_description": "Rice, chop suey, and sweet & sour pork.",
          "dish_price": "$55,000"
        }
      ]
    },
    {
      "name": "Lo Mein",
      "items": [
        {
          "dish_name": "Prawn Lo Mein",
          "dish_description": "Lo mein with prawns.",
          "dish_price": "$74,000"
        },
        {
          "dish_name": "Chicken Lo Mein",
          "dish_description": "Lo mein with chicken.",
          "dish_price": "$58,000"
        },
        {
          "dish_name": "Beef Lo Mein",
          "dish_description": "Lo mein with beef.",
          "dish_price": "$60,000"
        }
      ]
    },
    {
      "name": "ToFu Dishes",
      "items": [
        {
          "dish_name": "Tofu Chicken",
          "dish_description": "Tofu with chicken.",
          "dish_price": "$58,000"
        },
        {
          "dish_name": "Tofu Beef",
          "dish_description": "Tofu with beef.",
          "dish_price": "$60,000"
        },
        {
          "dish_name": "Mapo Tofu",
          "dish_description": "Spicy Mapo tofu.",
          "dish_price": "$61,000"
        },
        {
          "dish_name": "Tofu Prawn",
          "dish_description": "Tofu with prawns.",
          "dish_price": "$74,000"
        }
      ]
    },
    {
      "name": "Kids' Menu",
      "items": [
        {
          "dish_name": "French Fries & Chicken Croquettes",
          "dish_description": "Served with sweet and sour sauce.",
          "dish_price": "$"
        }
      ]
    },
    {
      "name": "Meats",
      "items": [
        {
          "dish_name": "Pepper Steak",
          "dish_description": "Beef with pepper, onion, and bell pepper in soy sauce.",
          "dish_price": "$62,000"
        },
        {
          "dish_name": "Grilled/Breaded Chicken",
          "dish_description": "Chicken served with French fries and salad.",
          "dish_price": "$60,000"
        },
        {
          "dish_name": "Sirloin Steak with Wine Sauce Vegetables",
          "dish_description": "Beef tenderloin with vegetables in wine sauce.",
          "dish_price": "$63,000"
        },
        {
          "dish_name": "Filet Mignon with Mushrooms",
          "dish_description": "Filet mignon with mushrooms and French fries.",
          "dish_price": "$63,000"
        },
        {
          "dish_name": "Grilled Sirloin Steak",
          "dish_description": "Grilled beef tenderloin with French fries and salad.",
          "dish_price": "$63,000"
        },
        {
          "dish_name": "Roasted Pork",
          "dish_description": "Roasted pork served with French fries and salad.",
          "dish_price": "$62,000"
        },
        {
          "dish_name": "Portion of White Rice",
          "dish_description": "Side of white rice.",
          "dish_price": "$11,800"
        }
      ]
    },
    {
      "name": "Desserts",
      "items": [
        {
          "dish_name": "Coconut Flan",
          "dish_description": "Coconut flan.",
          "dish_price": "$22,000"
        },
        {
          "dish_name": "Caramel Flan",
          "dish_description": "Caramel flan.",
          "dish_price": "$22,000"
        },
        {
          "dish_name": "Cheesecake",
          "dish_description": "Cheesecake.",
          "dish_price": "$22,000"
        },
        {
          "dish_name": "Tapioca with Mango",
          "dish_description": "Tapioca dessert with mango.",
          "dish_price": "$23,000"
        }
      ]
    },
    {
      "name": "Tea",
      "items": [
        {
          "dish_name": "Chinese Tea",
          "dish_description": "Traditional Chinese tea.",
          "dish_price": "$9,900"
        }
      ]
    }
  ]
};


const exportObject = {
  MenuList,
  Cartaespañol,
  Cartachino,
  Cartausa,
};

export default exportObject;
